const activity = {
  activity: "Attività", // translated
  activities: "Attività", // translated
  dates: "date", // translated
  location: "Posizione", // translated
  languages: "Le lingue", // translated
  categories: "Categorie", // translated
  ticketOption: "Opzione biglietto", // translated
  numberOfRatings: "Numero di valutazioni", // translated
  meetingPointInfo: "Informazioni sul punto d'incontro", // translated
  meetingPoint: "Punto d'incontro", // translated
  meetingPoints: "Punti d'incontro", // translated
  providedBy: "Fornito da", // translated
  expirationDate: "Data di scadenza", // translated
  groupSize: "Dimensione del gruppo", // translated
  features: "Caratteristiche", // translated
  basedOn: "Basato su", // translated
  reviewsFromVerCustomers: "recensioni di clienti verificati", // translated
  excellent: "eccellente", // translated
  great: "Grande", // translated
  average: "media", // translated
  poor: "povero", // translated
  bad: "Cattivo", // translated
  onlyBookedCustomersTooltip: "Solo i clienti che hanno prenotato questa attività possono lasciare una recensione", // translated
  noReviewsYet: "Al momento non ci sono recensioni per questa attività.", // translated
  backToActivitiesList: "Torna all'elenco delle attività", // translated
  getPrices: "ottenere i prezzi", // translated
  availabilityAndPrices: "Disponibilità e prezzi", // translated
  ticketOptions: "Opzioni del biglietto", // translated
  ticketInfo: "Informazioni sui biglietti", // translated
  selectYourTickets: "Seleziona i tuoi biglietti", // translated
  product: "Prodotto", // translated
  total: "Totale", // translated
  slot: "Fessura", // translated
  language: "Lingua", // translated
  tickets: "Biglietti", // translated
  ticketsFor: "Biglietti per", // translated
  previousStep: "Passo precedente", // translated
  onlyAvailableInEnglish: "Disponibile solo in inglese", // translated
  guest: "Ospite", // translated
  leadGuest: "Ospite principale", // translated
  adult: "Adulto", // translated
  child: "Bambino", // translated
  pleaseSelectAdult: "Seleziona almeno un adulto", // translated
  notAvailableActivity: "Questo prodotto non è disponibile", // translated
  required: "Necessario", // translated
  pickupPoint: "Punto di ritiro", // translated
  pickupPoints: "Punti di ritiro", // translated
  ticketType: "Tipo di biglietto", // translated
  anonymous: "Anonimo", // translated
  printedVoucher: "Voucher stampato accettato", // translated
  mobileVoucher: "Voucher mobile accettato", // translated
  mixedVoucher: "Voucher mobile o stampato accettato", // translated
  safetyMeasures: "Misure di sicurezza applicate", // translated
  doThisBecause: "Fallo perché", // translated
  safetyInfo: "Informazioni sulla sicurezza", // translated
  reviewsHighestFirst: "Numero di recensioni (prima il più alto)", // translated
  bookingFee: "Tassa di prenotazione", // translated
  startDate: "Data d'inizio", // translated
  endDate: "Data di fine", // translated
  cancellationDeadlineAndFees: "Termine ultimo e spese di cancellazione", // translated
  resetTickets: "Reimposta i biglietti", // translated
  instantConfirmation: "Conferma immediata", // translated
  clickResetBtn: "Fare clic sul pulsante di ripristino per ricominciare la selezione", // translated
};

export default activity;
